module.exports = __webpack_public_path__ + "img/nuevo-producto.9153fea6.svg";